import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl) throw new Error('REACT_APP_SUPABASE_URL is required');
if (!supabaseAnonKey) throw new Error('REACT_APP_SUPABASE_ANON_KEY is required');

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Cache access token to avoid lock contention from concurrent getSession() calls.
// Updated by onAuthStateChange listener (fires for SIGNED_IN, TOKEN_REFRESHED, SIGNED_OUT).
let _cachedAccessToken = null;

supabase.auth.onAuthStateChange((_event, session) => {
    _cachedAccessToken = session?.access_token || null;
});

supabase.auth.getSession().then(({ data: { session } }) => {
    _cachedAccessToken = session?.access_token || null;
});

export const getCachedAccessToken = () => _cachedAccessToken;
